import React, { Component } from 'react'
import './EventPopupWindow.scss'

import { connect } from 'react-redux'
import i18n from '@/i18n'
import Slick from 'react-slick'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { PopupsApis } from '@/utils/Videomonster/Apis'
import { ErrorHandler } from '@/utils/Error/Handler';

class EventPopupWindow extends Component {
    state = {
        popups: [],
        isOpen: false
    }
    slickRef
    dragging = false;

    componentDidMount() {
        this.getPopupsData()
    }

    componentDidUpdate(prevProps) {
        const { lang } = this.props
        if (lang !== prevProps.lang) {
            this.componentDidMount()
        }
    }

    getPopupsData = async () => {
        try {
            const { lang } = this.props;
            const { result, data } = await PopupsApis.GetPopupsData({
                country: lang,
                filter: 1,
            });
            if (result && data && data.list.length) {
                const popups = data.list.filter(({ _id, thumbnailURL }) => (!localStorage.getItem(`PEPC_${_id}`) && thumbnailURL));
                this.setState({ isOpen: true, popups });
            }
        } catch (e) {
            ErrorHandler(this, null);
        }
    }

    handleClickNeverMind = () => {
        const { popups } = this.state;
        popups.forEach(({ _id }) => { localStorage.setItem(`PEPC_${_id}`, true) });
        this.setState({ isOpen: false })
    }

    handleClickClose = () => this.setState({ isOpen: false })

    handleClickPopup = (e, url) => {
        if (this.dragging || !url) return e.stopPropagation()
        window.open(url, '_blank');
    }

    handleClickPrvBtn = e => {
        e.stopPropagation()
        this.slickRef.slickPrev()
    }

    handleClickNextBtn = e => {
        e.stopPropagation()
        this.slickRef.slickNext()
    }

    render() {
        const { lang } = this.props
        const { isOpen, popups } = this.state

        const imgRatio = 300 / 400
        const imgStyle = { height: '550px', width: `${550 * imgRatio }px`}

        const settings = {
            dots: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            beforeChange: () => this.dragging = true,
            afterChange: () => this.dragging = false,
        }

        return (
            popups.length && isOpen ?
                <div className='event-popup-window-container'>
                    <div className='event-popup-window-img-area' style={imgStyle}>
                        <Slick {...settings} ref={ref => this.slickRef = ref} className={lang}>
                            {popups.length && popups.map(item => {
                                return <img
                                    key={item._id}
                                    className={item.clickURL ? "cursor" : ""}
                                    src={item.thumbnailURL}
                                    onClick={(e) => this.handleClickPopup(e, item.clickURL)}
                                    alt=""
                                />
                            })}
                        </Slick>
                        {
                            popups.length > 1 &&
                            <>
                                <div className='slider-btn prev' onClick={this.handleClickPrvBtn}>◀</div>
                                <div className='slider-btn next' onClick={this.handleClickNextBtn}>▶</div>
                            </>
                        }
                    </div>
                    <div className='event-popup-window-btn-area'>
                        <div className='btn-never-mind' onClick={this.handleClickNeverMind}>
                            {i18n.t("web.event.popup.never.mind")}
                        </div>
                        <div className='btn-popup-close' onClick={this.handleClickClose}>
                            {i18n.t("global.close")}
                        </div>
                    </div>
                </div>
                :
                <></>
        )
    }
}

const mapStateToProps = state => ({
    currentUser: state.userStore.user,
    lang: state.langStore.lang
})

export default connect(mapStateToProps, null)(EventPopupWindow)